import { createAsyncThunk } from "@reduxjs/toolkit";
import apiCall from "../AuthorizedApi";
import axios from "axios";
import { getHostUrl } from "../getHostUrl";

export const getEventSchedulingStatsAPI = createAsyncThunk(
    'event/getEventSchedulingStatsAPI',
    async (params: { start_date: string; end_date: string; branch_id?: number | string | null }, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams({
                start_date: params.start_date,
                end_date: params.end_date,
                ...(params.branch_id ? { branch_id: String(params.branch_id) } : {})
            }).toString();
            const response = await apiCall({
                method: 'GET',
                url: `/project/user-event/?${queryParams}`,
            });
            return response;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data ?? error);
        }
    }
);

export const getAllEventsAPI = createAsyncThunk(
    'event/getAllEventsAPI',
    async (data: { start_date: string, end_date: string, branch_id?: number | string | null }, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams({
                start_date: data.start_date,
                end_date: data.end_date,
                ...(data.branch_id ? { branch_id: String(data.branch_id) } : {})
            }).toString();
            const response = await apiCall({
                method: 'GET',
                url: `/project/user-event/?${queryParams}`,
            })

            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });

export const createEventAPI = createAsyncThunk(
    'event/createEventAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: '/project/user-event/',
                data: data
            })
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });
export const updateEventAPI = createAsyncThunk(
    'event/updateEventAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'PUT',
                url: '/project/user-event/',
                data: data
            })
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });
export const deleteEventAPI = createAsyncThunk(
    'event/deleteEventAPI',
    async (data: { id: number }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'DELETE',
                url: `/project/user-event/?business_event_id=${data.id}`,

            })
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });
export const getEventFormTokenAPI = createAsyncThunk(
    'event/getEventFormTokenAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: `/account/user/form-token/`,

            })
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    })

export const submitEventFormAPI = createAsyncThunk(
    'event/submitEventFormAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${getHostUrl()}/project/customer-event/`,
                data

            })
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    })

export const getUserCreatedEventsAPI = createAsyncThunk<any, { branch_id?: number | string | null } | void>(
    'event/getUserCreatedEventsAPI',
    async (params, { rejectWithValue }) => {
        try {
            const query = params?.branch_id ? `?branch_id=${params.branch_id}` : '';
            const response = await apiCall({
                method: 'GET',
                url: `/project/customer-event/${query}`,
            })
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    })
export const deleteUserCreatedEventAPI = createAsyncThunk(
    'event/deleteUserCreatedEventAPI',
    async (data: { event_id: number }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'DELETE',
                url: `/project/customer-event/?customer_event_id=${data.event_id}`,


            })
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    })


export const getEventAvailableMembers = createAsyncThunk(
    'event/getEventAvailableMembers',
    async (params: { start_date?: string, start_time?: string, end_time?: string, }, { rejectWithValue }) => {
        try {
            const { start_date, start_time, end_time } = params || {};
            const queryParams = new URLSearchParams({
                ...(start_date && { start_date }),
                ...(start_time && { start_time }),
                ...(end_time && { end_time }),
            }).toString();

            const response = await apiCall({
                method: 'GET',
                url: `/account/user/team-member/?${queryParams}`,
            })
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });

export const getEventNamesAPI = createAsyncThunk(
    'event/getEventNamesAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: '/project/event-name/'
            })
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });

export const createEventNameAPI = createAsyncThunk(
    'event/createEventNameAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: '/project/user-choice-event/',
                data: { event_name: data?.event_name }
            })
            console.log('response.data :>> ', response?.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    });

export const deleteEventNameAPI = createAsyncThunk(
    'event/deleteEventNameAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: "DELETE",
                url: '/project/user-choice-event/',
                data: { event_ids: data }
            })
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
)
export const sendEventDataToMemberOnWhatsAppAPI = async (data: any) => {
    try {
        const response = await apiCall({
            method: "POST",
            url: '/project/api/send-whatsapp-event/',
            data
        })
        return response;
    } catch (error: any) {
        throw error
    }
}





